import React from "react";
import Newsletter_38 from "../component/Newsletter_38";

function Newsletter_38Container() {
  return <Newsletter_38 />;
}

export default Newsletter_38Container;
